import * as React from "react";
import type { SVGProps } from "react";
const SvgAiSparkles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={22}
    fill="none"
    viewBox="0 0 20 22" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M16.173 13.59c-5.281 1.285-6.548 2.609-7.742 8.217-.055.257-.443.257-.498 0C6.738 16.2 5.472 14.875.19 13.59a.237.237 0 0 1 0-.465c5.282-1.285 6.548-2.609 7.743-8.217.055-.257.443-.257.498 0 1.194 5.608 2.46 6.932 7.742 8.217a.237.237 0 0 1 0 .465ZM19.937 8.728c-1.761.467-2.183.948-2.581 2.988a.084.084 0 0 1-.166 0c-.398-2.04-.82-2.52-2.581-2.988-.085-.023-.085-.147 0-.17 1.76-.467 2.183-.948 2.58-2.988a.084.084 0 0 1 .167 0c.398 2.04.82 2.521 2.58 2.989.085.022.085.146 0 .169ZM15.391 3.227c-1.76.468-2.182.95-2.58 2.989a.084.084 0 0 1-.166 0c-.399-2.04-.82-2.521-2.581-2.989-.085-.022-.085-.146 0-.169 1.76-.467 2.182-.948 2.58-2.988a.084.084 0 0 1 .166 0c.399 2.04.82 2.52 2.581 2.988.085.023.085.147 0 .17Z"
    />
  </svg>
);
export default SvgAiSparkles;
